import { memo } from 'react';
// import { IconPlay05 } from '@wconcept/wconcept-ui-renewal/components/atoms/svg';

import * as S from './style';

interface IProps {
  onClick?: () => void;
}

const ViewStylVdBtn = ({ onClick }: IProps) => (
  <S.ViewStylVdBtn
    className="viewStyVd-btn"
    onClick={onClick}
    // icon={<IconPlay05 />} // 렌더링 이슈로 SVG를 base64로 인코딩된 이미지로 사용
  >
    스타일링 영상 보기
  </S.ViewStylVdBtn>
);

export default memo(ViewStylVdBtn);
